import React, { useState, useEffect, Fragment, useRef } from "react";
import { BanIcon, RefreshIcon, PencilIcon } from "@heroicons/react/outline";
import { ArrowNarrowLeftIcon } from "@heroicons/react/solid";
import Layout from "../../components/Layout/Layout";
import { useSearchParams } from "react-router-dom";
import CustomerDocument from "./customerDocument";
import CustomerSettings from "./CustomerSettngs";
import CustomerServices from "../../services/CustomerServices";
import { PREMIUM_MOBILE_APP_NAME } from "../../services/QuickOnlineAccountServices";
import { convert, validateDate } from "./../../utils/convertDate";
import fire from "./../../utils/Toastr";
import { HollowDotsSpinner } from "react-epic-spinners";
import { Dialog, Transition } from "@headlessui/react";
import ProfileUpdateModal from "../../components/Modals/Customer/ProfileUpdateModal";
import AccountUpdateModal from "../../components/Modals/Customer/AccountUpdateModal";
import ConfirmModal from "../../components/Modals/ConfirmModal";
import LivenessImagesPanel from "../../components/LivenessImagesPanel";

export default function ViewCustomer() {
  const statusStyles = {
    Active: "bg-green-500 text-white",
    Disabled: "bg-amber-400 text-white",
    Inactive: "bg-orange-600 text-white",
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const userNameParam = searchParams.get("id") || searchParams.get("userName");
  const userIdParam = searchParams.get("userId");
  const customerIdentifier = userIdParam
    ? { userId: userIdParam }
    : { userName: userNameParam };
  const setActiveTab = (tab) =>
    setSearchParams(
      userIdParam
        ? { userId: userIdParam, tab }
        : { id: userNameParam || "", tab },
    );
  const errors = {
    commentError: "",
    commentIsValidated: false,
    formIsSubmitting: false,
  };
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [profileUpdateModalOpen, setProfileUpdateModalOpen] = useState(false);
  const [formState, setFormState] = useState(errors);
  const [commentValue, setCommentValue] = useState({
    comment: "",
  });
  const [customer, setCustomer] = useState({});
  const [loading, setLoading] = useState(false);
  const [imgUrl, setImgUrl] = useState();
  const [imgUrl2, setImgUrl2] = useState();
  const [bvnImg, setBvnImg] = useState();
  const [ninDetails, setNinDetails] = useState(null);
  const [ninImg, setNinImg] = useState();
  const [account, setAccount] = useState([]);
  const [bvnName, setBVName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [bvnDetails, setBVNDet] = useState("");
  const [kinDetails, setKinDetails] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const [address, setAddress] = useState("");
  const [resAddress, setResAdress] = useState("");
  const [adminType, setAdminType] = useState("");
  const [pendingApproval, setPendingApproval] = useState(null);
  const [pendingReInitiateApproval, setPendingReInitiateApproval] =
    useState(null);
  const [pendingAccountApprovals, setPendingAccountApprovals] = useState(
    new Set(),
  );
  const [accountUpdateModalOpen, setAccountUpdateModalOpen] = useState(false);
  const [selectedAccountForUpdate, setSelectedAccountForUpdate] =
    useState(null);
  const [checkingApproval, setCheckingApproval] = useState(false);
  const [ninActionLoading, setNinActionLoading] = useState(null);
  const [reInitiateConfirmOpen, setReInitiateConfirmOpen] = useState(false);
  const resolvedUserName = customer?.userName || userNameParam;
  const isUnverified =
    String(customer?.registrationStage || "").toLowerCase() === "unverified";
  const requestedTab = searchParams.get("tab") || "overview";
  const activeTab =
    !resolvedUserName && ["documents", "settings"].includes(requestedTab)
      ? "overview"
      : requestedTab;

  // comment validation
  const formHandler = {
    commentHandler: (event) => {
      setCommentValue({ ...commentValue, comment: event.target.value });
      if (event.target.value.trim().length < 1) {
        setFormState({
          ...formState,
          commentError: "Comment cannot be empty",
          commentIsValidated: false,
        });
        return;
      }

      setFormState({
        ...formState,
        commentError: "",
        commentIsValidated: true,
      });
    },
  };

  const handleApprove = async () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleProfileUpdateClick = () => {
    setProfileUpdateModalOpen(true);
  };

  const handleProfileUpdateSuccess = () => {
    ViewCustomer();
    setPendingApproval({ status: "Initiated" });
    checkPendingApproval();
  };

  const checkPendingApproval = async () => {
    if (!customer?.userId || checkingApproval) return;

    setCheckingApproval(true);
    try {
      const response = await CustomerServices.listApprovals(
        1,
        50,
        "Initiated",
        "Customer",
      );
      if (response?.status && response.data?.result) {
        const pending = response.data.result.find(
          (a) => a.approvalIdentifier === String(customer.userId),
        );
        setPendingApproval(pending || null);
      } else {
        setPendingApproval(null);
      }

      const accountResponse = await CustomerServices.listAccountApprovals(
        1,
        50,
        "Initiated",
        "Accounts",
      );
      if (accountResponse?.status && accountResponse.data?.result) {
        const accountIds = (customer?.customerAccounts || [])
          .map((a) => a.id)
          .filter(Boolean);
        const pendingAccountIds = accountResponse.data.result
          .filter((a) => accountIds.includes(a.approvalIdentifier))
          .map((a) => a.approvalIdentifier);
        setPendingAccountApprovals(new Set(pendingAccountIds));
      } else {
        setPendingAccountApprovals(new Set());
      }

      const openingResponse =
        await CustomerServices.listAccountOpeningApprovals(
          1,
          50,
          "Initiated",
        );
      if (openingResponse?.status && openingResponse.data?.result) {
        const pendingReInitiate = openingResponse.data.result.find((a) => {
          const rowUserId = a?.requestData?.userId;
          if (rowUserId != null) {
            return String(rowUserId) === String(customer.userId);
          }
          return (
            !!resolvedUserName && a?.requestData?.userName === resolvedUserName
          );
        });
        setPendingReInitiateApproval(pendingReInitiate || null);
      } else {
        setPendingReInitiateApproval(null);
      }
    } catch (error) {
      console.error("Error checking approval:", error);
      setPendingApproval(null);
      setPendingReInitiateApproval(null);
      setPendingAccountApprovals(new Set());
    } finally {
      setCheckingApproval(false);
    }
  };

  const handleAccountUpdateSuccess = () => {
    ViewCustomer();
    if (selectedAccountForUpdate?.id) {
      setPendingAccountApprovals(
        (prev) => new Set([...prev, selectedAccountForUpdate.id]),
      );
    }
    checkPendingApproval();
  };

  const blockCustomer = async () => {
    const isFiiled = formState.commentIsValidated;
    if (!isFiiled) {
      fire("error", "Input field is required");
      return;
    }
    const block = await CustomerServices.blockCustomer({
      userName: resolvedUserName,
      comment: commentValue.comment,
    });
    if (block) {
      fire("success", block.message);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  };

  const unblockCustomer = async () => {
    setLoading(true);
    if (
      adminType.toLowerCase() === "maker" &&
      customer?.activationApprovalStatus?.toLowerCase() === "initiated"
    ) {
      setLoading(false);
      fire(
        "error",
        "This has already been initiated and awaiting approval of a checker",
      );
      return;
    }

    if (
      adminType.toLowerCase() === "checker" &&
      customer?.activationApprovalStatus?.toLowerCase() !== "initiated"
    ) {
      fire("error", "Maker approval action is required first");
      setLoading(false);
      return;
    }
    const response = await CustomerServices.UnBlockCustomer({
      userName: resolvedUserName,
    });
    if (response) {
      fire("success", response.message);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
      setLoading(false);
    }
  };

  const reactivateCustomer = async (e) => {
    e.preventDefault();
    setLoading(true);
    const block = await CustomerServices.unLockCustomer({
      userName: resolvedUserName,
    });
    if (block) {
      fire("success", block.message);
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }

    setLoading(false);
  };

  const ViewCustomer = async () => {
    try {
      const customer = await CustomerServices.viewCustomer(customerIdentifier);
      setLoadError(false);
      setCustomer(customer?.data);
      setBVName(customer?.data?.bvn);
      setCustomerName(customer?.data?.userName);
      setBVNDet(customer?.data?.bvnNavigation);
      setNinDetails(customer?.data?.ninDetail ?? null);
      setKinDetails(customer?.data?.nextOfKin ?? null);
      setAddress(customer?.data?.encondedLocationUrl);
      setResAdress(customer?.data?.residentialAddress);

      var details = sessionStorage.getItem("user");
      var userDetails = JSON.parse(details);
      var type = userDetails.adminType;
      setAdminType(type);

      if (customer?.data) {
        setAccount([...(customer?.data?.customerAccounts || [])]);

        // Always try to load selfieUrl (even if null)
        try {
          if (customer?.data?.selfieUrl) {
            const response = await fetch(customer?.data?.selfieUrl);
            if (response.ok) {
              const imageBlob = await response.blob();
              const reader = new FileReader();
              reader.readAsDataURL(imageBlob);
              reader.onloadend = () => {
                const base64data = reader.result;
                setImgUrl(base64data);
              };
            }
          }
        } catch (error) {
          console.error("Error loading selfie image:", error);
          setImgUrl(null);
        }

        // Only load deviceChangeSelfieUrl if it exists
        if (customer?.data?.deviceChangeSelfieUrl) {
          try {
            const response = await fetch(customer?.data?.deviceChangeSelfieUrl);
            if (response.ok) {
              const imageBlob = await response.blob();
              const reader = new FileReader();
              reader.readAsDataURL(imageBlob);
              reader.onloadend = () => {
                const base64data = reader.result;
                setImgUrl2(base64data);
              };
            }
          } catch (error) {
            console.error("Error loading device change image:", error);
          }
        }

        // Handle BVN image
        if (customer?.data?.bvnNavigation?.base64Image) {
          try {
            const nresponse = await fetch(
              customer?.data?.bvnNavigation?.base64Image,
            );
            const nimageBlob = await nresponse.blob();
            const nreader = new FileReader();
            nreader.readAsDataURL(nimageBlob);
            nreader.onloadend = () => {
              const base64data = nreader.result;
              setBvnImg(base64data);
            };
          } catch (error) {
            console.error("Error loading BVN image:", error);
          }
        }

        // Handle NIN image
        if (customer?.data?.ninDetail?.imageUrl) {
          try {
            const ninImageUrl = customer?.data?.ninDetail?.imageUrl;
            if (/^(https?:|data:)/i.test(ninImageUrl)) {
              setNinImg(ninImageUrl);
            } else {
              const ninResponse = await fetch(ninImageUrl);
              const ninImageBlob = await ninResponse.blob();
              const ninReader = new FileReader();
              ninReader.readAsDataURL(ninImageBlob);
              ninReader.onloadend = () => {
                setNinImg(ninReader.result);
              };
            }
          } catch (error) {
            console.error("Error loading NIN image:", error);
          }
        }
      }
    } catch (error) {
      console.error("Error loading customer:", error);
      setLoadError(true);
      setCustomer({});
      setKinDetails(null);
      setAccount([]);
    }
  };

  // Separate useEffect for checking pending approval
  useEffect(() => {
    if (customer?.userId) {
      // Add a small delay to avoid race conditions
      const timer = setTimeout(() => {
        checkPendingApproval();
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [customer?.userId]);

  const syncBVN = async () => {
    setLoading(true);
    const resp = await CustomerServices.syncBVN({
      bvn: bvnName,
      userName: customerName,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }

    setLoading(false);
  };

  const isFailure = (res) =>
    !res || res.status === false || res.status === "error";

  const syncNIN = async () => {
    const nin = customer?.nin || ninDetails?.nin;
    if (!nin) {
      fire("error", "NIN is not available for this customer");
      return;
    }
    setNinActionLoading("sync");
    try {
      const resp = await CustomerServices.syncNinDetails(
        { nin, userName: resolvedUserName },
        true,
      );
      if (isFailure(resp)) {
        fire("error", resp?.message || "NIN sync failed");
        return;
      }
      fire("success", resp?.message || "NIN sync completed successfully");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Error syncing NIN:", error);
      fire("error", "Failed to sync NIN details");
    } finally {
      setNinActionLoading(null);
    }
  };

  const reInitiateCustomer = async () => {
    setNinActionLoading("reinitiate");
    try {
      const resp = await CustomerServices.reInitiateOnboarding(
        {
          userId: customer?.userId ?? 0,
          uniqueIdentifier:
            customer?.nin ||
            ninDetails?.nin ||
            customer?.bvn ||
            resolvedUserName ||
            null,
          userName: resolvedUserName ?? null,
        },
        true,
      );
      if (isFailure(resp)) {
        fire("error", resp?.message || "Re-initiation failed");
        return;
      }
      fire("success", resp?.message || "Onboarding re-initiated successfully");
      setPendingReInitiateApproval({ status: "Initiated" });
      checkPendingApproval();
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Error re-initiating customer onboarding:", error);
      fire("error", "Failed to re-initiate customer onboarding");
    } finally {
      setNinActionLoading(null);
      setReInitiateConfirmOpen(false);
    }
  };

  const blockAccount = async () => {
    setLoading(true);
    const resp = await CustomerServices.blockAccount(resolvedUserName);
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }

    setLoading(false);
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  useEffect(() => {
    ViewCustomer();
  }, []);

  if (loadError) {
    return (
      <>
        <Layout title={""} pageTag={"customer"} current={"/customers"}>
          <main className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <div className="py-8">
              <div className="bg-white rounded-lg p-8 text-center max-w-lg mx-auto">
                <h2 className="text-lg font-bold text-gray-900 mb-2">
                  Unable to load customer
                </h2>
                <p className="text-sm text-gray-500 mb-6">
                  The customer service is currently unavailable. Please try
                  again later.
                </p>
                <div className="flex justify-center gap-4">
                  <button
                    onClick={() => {
                      setLoadError(false);
                      ViewCustomer();
                    }}
                    className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md"
                  >
                    <RefreshIcon className="w-4 h-4 mr-2" />
                    Retry
                  </button>
                  <a
                    href={`/customers`}
                    className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md"
                  >
                    <ArrowNarrowLeftIcon className="w-6 h-4 mr-1" />
                    Back to Customers
                  </a>
                </div>
              </div>
            </div>
          </main>
        </Layout>
      </>
    );
  }

  return (
    <>
      <Layout title={""} pageTag={"customer"} current={"/customers"}>
        <main>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <div className="py-4">
              <a href={`/customers`}>
                <div className="flex">
                  <ArrowNarrowLeftIcon className="w-6 h-4 flex self-center" />
                  <p> Back</p>
                </div>
              </a>

              <div
                className={`mt-1 relative rounded-md flex justify-center ${
                  customer?.deviceChangeSelfieUrl && "gap-5"
                }`}
              >
                {/* Always show selfie container, even if empty */}
                <div className="flex flex-col gap-2 font-semibold uppercase">
                  <p>Initial Capture</p>
                  {imgUrl ? (
                    <img
                      className="inline-block h-28 w-28 rounded-full border-8 border-rose-600"
                      src={imgUrl}
                      alt="Initial capture"
                    />
                  ) : (
                    <div className="inline-block h-28 w-28 rounded-full border-8 border-rose-600 bg-white items-center justify-center">
                      <span className="text-xs text-gray-500"></span>
                    </div>
                  )}
                </div>

                {/* Only show device change container if imgUrl2 exists */}
                {imgUrl2 && (
                  <div className="flex flex-col gap-2 font-semibold uppercase">
                    <p>Device Change</p>
                    <img
                      className="inline-block h-28 w-28 rounded-full border-8 border-rose-600"
                      src={imgUrl2}
                      alt="Device change capture"
                    />
                  </div>
                )}
              </div>
              <div className="flex justify-center">
                <div className="font-bold">
                  {customer?.firstName} {customer?.surname}{" "}
                  <span
                    className={classNames(
                      statusStyles[customer?.customerStatus],
                      "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900",
                    )}
                  >
                    {customer?.customerStatus}
                  </span>{" "}
                  <br />
                  <span className="text-sm text-center ml-4 flex justify-evenly font-thin">
                    {" "}
                    Username:
                    <span className="text-green-400 font-thin">
                      {customer?.userName}
                    </span>
                  </span>{" "}
                </div>
              </div>
              <div className="mt-4 items-center sm:mt-0 sm:ml-16 sm:flex justify-end relative bottom-10">
                {resolvedUserName &&
                  (customer?.customerStatus === "Active" ? (
                    <>
                      {loading === false ? (
                        <button
                          type="submit"
                          onClick={handleApprove}
                          className="mr-2 hover:text-white active:text-white inline-flex btn-error items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-error shadow-sm sm:w-auto"
                        >
                          <BanIcon className="w-3 mr-1.5" />
                          Block Customer
                        </button>
                      ) : (
                        <HollowDotsSpinner size={20} color="#4D627E" />
                      )}
                    </>
                  ) : (
                    <>
                      {loading === false ? (
                        <button
                          type="submit"
                          onClick={unblockCustomer}
                          className="mr-2 hover:text-white bg-green-400 active:text-white inline-flex btn-green items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-green-400 shadow-sm sm:w-auto"
                        >
                          <BanIcon className="w-3 mr-1.5" />
                          Unblock Customer
                        </button>
                      ) : (
                        <HollowDotsSpinner size={20} color="#079D4F" />
                      )}
                    </>
                  ))}
                {/* Re-initiate button - top level */}
                {isUnverified &&
                  adminType?.toLowerCase() === "maker" &&
                  (pendingReInitiateApproval ? (
                    <span className="inline-flex items-center px-4 py-2 text-sm font-medium text-yellow-700 bg-yellow-50 border border-yellow-300 rounded-md">
                      Initiated, waiting on checker
                    </span>
                  ) : (
                    <button
                      type="button"
                      onClick={() => setReInitiateConfirmOpen(true)}
                      disabled={ninActionLoading !== null}
                      className="inline-flex items-center justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-60"
                    >
                      {ninActionLoading === "reinitiate" ? (
                        <HollowDotsSpinner
                          size={12}
                          color="#FFFFFF"
                          className="mr-1.5"
                        />
                      ) : (
                        <RefreshIcon className="w-3 mr-1.5" />
                      )}
                      Re-initiate
                    </button>
                  ))}
              </div>
              {customer?.customerStatus !== "Active" ? (
                <div className="mt-8 items-center mr-10 sm:flex justify-end relative bottom-10">
                  <div className="tooltip">
                    <p className="text-rose-600">
                      Reason for blocking customer
                    </p>
                    <span className="tooltiptext ">
                      {" "}
                      <p className="m-4 text-left">
                        {customer?.reasonForDeactivation}
                      </p>
                    </span>
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="mt-2 border-b border-gray-200">
                <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                  {[
                    { key: "overview", label: "Overview" },
                    ...(resolvedUserName
                      ? [{ key: "documents", label: "Documents" }]
                      : []),
                    { key: "bvn", label: "BVN" },
                    { key: "nin", label: "NIN" },
                    { key: "image", label: "Identity Image" },
                    ...(resolvedUserName
                      ? [{ key: "settings", label: "Settings" }]
                      : []),
                  ].map((tab) => (
                    <button
                      key={tab.key}
                      type="button"
                      onClick={() => setActiveTab(tab.key)}
                      className={classNames(
                        activeTab === tab.key
                          ? "border-red-600 text-red-600"
                          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                        "whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm focus:outline-none",
                      )}
                    >
                      {tab.label}
                    </button>
                  ))}
                </nav>
              </div>

              <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto flex"></div>
                </div>
                <div className="mt-8 flex flex-col">
                  {activeTab !== "documents" && activeTab !== "settings" && (
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <form>
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                          {activeTab === "overview" && (
                            <div>
                              <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                                  {/* form */}
                                  <div className="p-6">
                                    <div className="flex justify-between">
                                      <h4 className="font-bold">NAMES</h4>
                                      {customer?.isLocked === true &&
                                      resolvedUserName ? (
                                        <button
                                          type="submit"
                                          onClick={reactivateCustomer}
                                          className="mr-2 hover:text-white active:text-white bg-green-400 inline-flex btn-green items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-green-400 shadow-sm sm:w-auto"
                                        >
                                          <BanIcon className="w-3 mr-1.5" />
                                          Reactivate Customer
                                        </button>
                                      ) : (
                                        ""
                                      )}
                                    </div>

                                    <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                      <div className="sm:col-span-1">
                                        <label
                                          htmlFor="first-name"
                                          className=" block text-sm font-medium text-gray-700"
                                        >
                                          Title{" "}
                                          <span className="text-red-600">
                                            *
                                          </span>
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="title"
                                            disabled
                                            defaultValue={
                                              bvnDetails?.title ??
                                              customer?.title
                                            }
                                            id="title"
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="firstName"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          First name{" "}
                                          <span className="text-red-600">
                                            *
                                          </span>
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="firstName"
                                            disabled
                                            defaultValue={customer?.firstName}
                                            id="firstName"
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-1">
                                        <label
                                          htmlFor="middleName"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Middle Name
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="middleName"
                                            disabled
                                            defaultValue={customer?.middleName}
                                            id="middleName"
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="lastName"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Last Name{" "}
                                          <span className="text-red-600">
                                            *
                                          </span>
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="lastName"
                                            id="lastName"
                                            disabled
                                            defaultValue={customer?.surname}
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                                  {/* form */}
                                  <div className="px-6 py-6">
                                    <div className="flex items-center justify-between p-2">
                                      <h4 className="font-bold">
                                        PERSONAL INFORMATION
                                      </h4>
                                      {/* Profile Update Button - Only for Makers when no pending approval */}
                                      {adminType &&
                                        adminType.toLowerCase() === "maker" &&
                                        (pendingApproval ? (
                                          <span className="inline-flex items-center px-4 py-2 text-sm font-medium text-yellow-700 bg-yellow-50 border border-yellow-300 rounded-md">
                                            Initiated, waiting on checker
                                          </span>
                                        ) : (
                                          <button
                                            type="button"
                                            onClick={handleProfileUpdateClick}
                                            className="mr-2 inline-flex items-center justify-center rounded-md border border-transparent bg-slate-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 sm:w-auto"
                                          >
                                            <PencilIcon className="w-4 mr-1.5" />
                                            Update Profile
                                          </button>
                                        ))}
                                    </div>
                                    <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="dob"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Date of Birth
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="dob"
                                            id="dob"
                                            disabled
                                            value={convert(
                                              customer?.dateOfBirth,
                                            )}
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-1">
                                        <label
                                          htmlFor="gender"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Gender
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="gender"
                                            id="gender"
                                            disabled
                                            defaultValue={customer?.gender}
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-1">
                                        <label
                                          htmlFor="maritalStatus"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Marital Status
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="maritalStatus"
                                            id="maritalStatus"
                                            disabled
                                            defaultValue={
                                              customer?.maritalStatus
                                            }
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="nin"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Inputted NIN
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="nin"
                                            id="nin"
                                            disabled
                                            defaultValue={customer?.nin ?? ""}
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="phone"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Phone Number
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="phone"
                                            id="phone"
                                            disabled
                                            defaultValue={customer?.phoneNumber}
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="email"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Email
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="email"
                                            disabled
                                            defaultValue={
                                              customer?.emailAddress
                                            }
                                            id="email"
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="email"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Alias
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="email"
                                            disabled
                                            defaultValue={
                                              customer?.customerAlias
                                            }
                                            id="email"
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>

                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="email"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Occupation
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="email"
                                            disabled
                                            defaultValue={customer?.occupation}
                                            id="email"
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>

                                      <div className="sm:col-span-2 mt-1">
                                        <label
                                          htmlFor="maiden"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Location at signup
                                        </label>
                                        <a
                                          target="blank"
                                          href={`${process.env.REACT_APP_MAP}${address}`}
                                          className="mr-2 hover:text-white active:text-white inline-flex bg-green-400 items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                                        >
                                          View Location
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                                  {/* form */}
                                  <div className="p-6">
                                    <div className="flex justify-between items-center mb-4">
                                      <h4 className="font-bold">
                                        ACCOUNT INFORMATION
                                      </h4>
                                      <div className="flex gap-2">
                                        {resolvedUserName &&
                                          (loading === false ? (
                                            <button
                                              type="submit"
                                              onClick={blockAccount}
                                              className="inline-flex btn-error items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-error shadow-sm"
                                            >
                                              <BanIcon className="w-3 mr-1.5" />
                                              Block Account
                                            </button>
                                          ) : (
                                            <HollowDotsSpinner
                                              size={20}
                                              color="#4D627E"
                                            />
                                          ))}
                                      </div>
                                    </div>

                                    {account.map((acct, i) => (
                                      <Fragment key={i}>
                                        <div className="mt-6 grid ">
                                          <div className=" ">
                                            <div className="flex">
                                              <div className="mr-3 w-1/2">
                                                <label
                                                  htmlFor="account"
                                                  className="block text-sm font-medium text-gray-700"
                                                >
                                                  Account Name {i + 1}
                                                </label>
                                                <div className="mt-1">
                                                  <input
                                                    type="text"
                                                    name="account"
                                                    id="account"
                                                    disabled
                                                    defaultValue={
                                                      acct.accountName
                                                    }
                                                    className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                                  />
                                                </div>
                                              </div>
                                              <div className="mr-3 w-1/2">
                                                <label
                                                  htmlFor="account"
                                                  className="block text-sm font-medium text-gray-700"
                                                >
                                                  Account Number {i + 1}
                                                </label>
                                                <div className="mt-1">
                                                  <input
                                                    type="text"
                                                    name="account"
                                                    id="account"
                                                    disabled
                                                    defaultValue={
                                                      acct.accountNumber
                                                    }
                                                    className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                                  />
                                                </div>
                                              </div>
                                              <div className="mr-3 w-1/2">
                                                <label
                                                  htmlFor="accountType"
                                                  className="block text-sm font-medium text-gray-700"
                                                >
                                                  Account Type {i + 1}
                                                </label>
                                                <div className="mt-1">
                                                  <input
                                                    type="text"
                                                    name="accountType"
                                                    id="accountType"
                                                    disabled
                                                    defaultValue={
                                                      acct.accountType
                                                    }
                                                    className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                                  />
                                                </div>
                                              </div>
                                              <div className="w-1/2">
                                                <label
                                                  htmlFor="accountType"
                                                  className="block text-sm font-medium text-gray-700"
                                                >
                                                  PND Restriction {i + 1}
                                                </label>
                                                <div className="mt-1">
                                                  <input
                                                    type="text"
                                                    name="accountType"
                                                    id="accountType"
                                                    disabled
                                                    defaultValue={
                                                      acct.accountOnPnd ===
                                                      false
                                                        ? "Not Blocked"
                                                        : "Blocked"
                                                    }
                                                    className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="mt-3">
                                          {adminType?.toLowerCase() ===
                                            "maker" &&
                                            !pendingAccountApprovals.has(
                                              acct.id,
                                            ) && (
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  setSelectedAccountForUpdate(
                                                    acct,
                                                  );
                                                  setAccountUpdateModalOpen(
                                                    true,
                                                  );
                                                }}
                                                className="inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-slate-600 hover:bg-slate-700"
                                              >
                                                <PencilIcon className="w-4 h-4 mr-1" />
                                                Update Account Profile
                                              </button>
                                            )}
                                          {adminType?.toLowerCase() ===
                                            "maker" &&
                                            pendingAccountApprovals.has(
                                              acct.id,
                                            ) && (
                                              <span className="inline-flex items-center px-4 py-2 text-sm font-medium text-yellow-700 bg-yellow-50 border border-yellow-300 rounded-md">
                                                Initiated, waiting on checker
                                              </span>
                                            )}
                                        </div>
                                      </Fragment>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {activeTab === "bvn" && (
                            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5 p-4">
                              <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                                {/* form */}
                                <div className="p-6">
                                  <div className="flex justify-between">
                                    <h4 className="font-bold">BVN DETAILS</h4>
                                    <div className=" sm:mt-0 sm:ml-16 sm:flex justify-end relative flex-none">
                                      {loading === false ? (
                                        <button
                                          type="button"
                                          onClick={syncBVN}
                                          className=" btn-primary align-center flex justify-center items-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm sm:w-auto"
                                        >
                                          <RefreshIcon className="w-3 mr-1.5" />
                                          Sync Details
                                        </button>
                                      ) : (
                                        <HollowDotsSpinner
                                          size={20}
                                          color="#4D627E"
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className=" justify-center flex mb-4">
                                  <div className="mt-1 relative rounded-md flex justify-center">
                                    <img
                                      className="inline-block h-28 w-28 rounded-full border-8 border-rose-600"
                                      src={bvnImg}
                                      alt=""
                                    />
                                  </div>
                                </div>
                                <div className=" grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="title"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Title
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvn"
                                        id="bvn"
                                        disabled
                                        defaultValue={bvnDetails?.title}
                                        className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnName"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      First Name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnName"
                                        id="bvnName"
                                        disabled
                                        defaultValue={bvnDetails?.firstName}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnName"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Last Name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnName"
                                        id="bvnName"
                                        disabled
                                        defaultValue={bvnDetails?.lastName}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvn"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Bank Verification Number(BVN)
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvn"
                                        id="bvn"
                                        disabled
                                        defaultValue={bvnDetails?.bvn}
                                        className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>

                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnBank"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Bank Registered
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnBank"
                                        id="bvnBank"
                                        disabled
                                        defaultValue={
                                          bvnDetails?.enrollmentBank
                                        }
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnYear"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Date of Registration
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnYear"
                                        id="bvnYear"
                                        disabled
                                        value={validateDate(
                                          bvnDetails?.registrationDate,
                                        )}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Phone Number Registered
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={bvnDetails?.phoneNumber}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Enrollment Branch
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={
                                          bvnDetails?.enrollmentBranch
                                        }
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Account Level
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={
                                          bvnDetails?.levelOfAccount
                                        }
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="dateOfBirth"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Date of Birth
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="dateOfBirth"
                                        id="dateOfBirth"
                                        disabled
                                        value={validateDate(
                                          bvnDetails?.dateOfBirth,
                                        )}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="gender"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Gender
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="gender"
                                        id="gender"
                                        disabled
                                        defaultValue={bvnDetails?.gender}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Marital Status
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={bvnDetails?.maritalStatus}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      State of Origin
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={bvnDetails?.stateOfOrigin}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      State of Residence
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={
                                          bvnDetails?.stateOfResidence
                                        }
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      WatchListed
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={bvnDetails?.watchListed}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      National Identification Number
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={bvnDetails?.nin}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Nationality
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={bvnDetails?.nationality}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      LGA of Origin
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={bvnDetails?.lgaOfOrigin}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      LGA of Residence
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={
                                          bvnDetails?.lgaOfResidence
                                        }
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Name on Card
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={bvnDetails?.nameOnCard}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Email Address
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={bvnDetails?.email}
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-6">
                                    <label
                                      htmlFor="bvnPhone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Residential Address
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="bvnPhone"
                                        id="bvnPhone"
                                        disabled
                                        defaultValue={
                                          bvnDetails?.residentialAddress
                                        }
                                        className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {activeTab === "nin" && (
                            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                              <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                                <div className="p-6">
                                  <div className="flex justify-between items-center">
                                    <h4 className="font-bold">NIN DETAILS</h4>
                                    <div className="flex items-center gap-2">
                                      <button
                                        type="button"
                                        onClick={syncNIN}
                                        disabled={ninActionLoading !== null}
                                        className="inline-flex items-center justify-center rounded-md border border-transparent bg-slate-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 disabled:opacity-60"
                                      >
                                        {ninActionLoading === "sync" ? (
                                          <HollowDotsSpinner
                                            size={12}
                                            color="#FFFFFF"
                                            className="mr-1.5"
                                          />
                                        ) : (
                                          <RefreshIcon className="w-3 mr-1.5" />
                                        )}
                                        Sync NIN
                                      </button>
                                    </div>
                                  </div>
                                  {ninDetails ? (
                                    <>
                                      <div className=" justify-center flex mb-4">
                                        <div className="mt-1 relative rounded-md flex justify-center">
                                          {ninImg ? (
                                            <img
                                              className="inline-block h-28 w-28 rounded-full border-8 border-rose-600"
                                              src={ninImg}
                                              alt=""
                                            />
                                          ) : (
                                            <div className="inline-block h-28 w-28 rounded-full border-8 border-rose-600 bg-white items-center justify-center">
                                              <span className="text-xs text-gray-500"></span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className=" grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="nin"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            National Identification Number
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="nin"
                                              id="nin"
                                              disabled
                                              defaultValue={
                                                ninDetails?.nin ?? "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninFirstName"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            First Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninFirstName"
                                              id="ninFirstName"
                                              disabled
                                              defaultValue={
                                                ninDetails?.firstName ?? "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninMiddleName"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Middle Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninMiddleName"
                                              id="ninMiddleName"
                                              disabled
                                              defaultValue={
                                                ninDetails?.middleName ?? "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninLastName"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Last Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninLastName"
                                              id="ninLastName"
                                              disabled
                                              defaultValue={
                                                ninDetails?.lastName ?? "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninDateOfBirth"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Date of Birth
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninDateOfBirth"
                                              id="ninDateOfBirth"
                                              disabled
                                              value={validateDate(
                                                ninDetails?.dateOfBirth,
                                              )}
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninGender"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Gender
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninGender"
                                              id="ninGender"
                                              disabled
                                              defaultValue={
                                                ninDetails?.gender ?? "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninPhoneNumber"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Phone Number
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninPhoneNumber"
                                              id="ninPhoneNumber"
                                              disabled
                                              defaultValue={
                                                ninDetails?.phoneNumber ?? "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninPhoneNumber1"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Phone Number 1
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninPhoneNumber1"
                                              id="ninPhoneNumber1"
                                              disabled
                                              defaultValue={
                                                ninDetails?.phoneNumber1 ??
                                                "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninEmail"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Email Address
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninEmail"
                                              id="ninEmail"
                                              disabled
                                              defaultValue={
                                                ninDetails?.email ?? "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninStateOfResidence"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            State of Residence
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninStateOfResidence"
                                              id="ninStateOfResidence"
                                              disabled
                                              defaultValue={
                                                ninDetails?.stateOfResidence ??
                                                "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninMatch"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Match
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninMatch"
                                              id="ninMatch"
                                              disabled
                                              defaultValue={
                                                ninDetails?.match ?? "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninBioMetricType"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Biometric Type
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninBioMetricType"
                                              id="ninBioMetricType"
                                              disabled
                                              defaultValue={
                                                ninDetails?.bioMetricType ??
                                                "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="ninBioMetricSubType"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Biometric Sub Type
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninBioMetricSubType"
                                              id="ninBioMetricSubType"
                                              disabled
                                              defaultValue={
                                                ninDetails?.bioMetricSubType ??
                                                "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                          <label
                                            htmlFor="ninMessage"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Message
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              name="ninMessage"
                                              id="ninMessage"
                                              disabled
                                              defaultValue={
                                                ninDetails?.message ?? "N/A"
                                              }
                                              className="bg-gray-100 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <div className="py-6 text-sm text-gray-500">
                                      No NIN details available for this
                                      customer.
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                          {activeTab === "image" && (
                            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                              <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                                <div className="p-6">
                                  <div className="flex justify-between">
                                    <h4 className="font-bold">
                                      IDENTITY IMAGE
                                    </h4>
                                  </div>
                                  <div className="justify-center flex py-6">
                                    {imgUrl ? (
                                      <img
                                        src={imgUrl}
                                        alt="Identity"
                                        className="inline-block h-80 w-80 object-cover rounded-lg border-2 border-gray-200 shadow-lg"
                                      />
                                    ) : (
                                      <div className="text-sm text-gray-500">
                                        No identity image available for this
                                        customer.
                                      </div>
                                    )}
                                  </div>
                                  <LivenessImagesPanel
                                    matchSelfieUrl={customer?.selfieUrl}
                                    appName={PREMIUM_MOBILE_APP_NAME}
                                    customerId={customer?.userId}
                                    title="Liveness Challenge Images"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                          {activeTab === "overview" && (
                            <div>
                              <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                                  {/* form */}
                                  <div className="p-6">
                                    <h4 className="font-bold">ADDRESS</h4>
                                    <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                      <div className="sm:col-span-3">
                                        <label
                                          htmlFor="state"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          State of Residence
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="state"
                                            id="state"
                                            disabled
                                            defaultValue={customer?.state}
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-3">
                                        <label
                                          htmlFor="state"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          LGA of Residence
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="state"
                                            id="state"
                                            disabled
                                            defaultValue={customer?.lga}
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-5">
                                        <label
                                          htmlFor="resAddress"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Residential Address
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="resAddress"
                                            id="resAddress"
                                            disabled
                                            defaultValue={
                                              customer?.residentialAddress
                                            }
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-1">
                                        <label
                                          htmlFor="resLocation"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          View Address
                                        </label>
                                        <a
                                          target="blank"
                                          href={`${process.env.REACT_APP_MAP}${resAddress}`}
                                          className="mr-2 hover:text-white active:text-white inline-flex bg-green-400 items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                                        >
                                          View
                                        </a>
                                      </div>
                                      <div className="sm:col-span-4">
                                        <label
                                          htmlFor="email"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Nearest Bus stop
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="email"
                                            disabled
                                            defaultValue={
                                              customer?.nearestBusStop
                                            }
                                            id="email"
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="email"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Landmark
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="email"
                                            disabled
                                            defaultValue={
                                              customer?.majorLandmark
                                            }
                                            id="email"
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                                  {/* form */}
                                  <div className="p-6">
                                    <h4 className="font-bold">NEXT OF KIN</h4>
                                    <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="kinSurname"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Surname
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="kinSurname"
                                            id="kinSurname"
                                            disabled
                                            defaultValue={
                                              kinDetails?.surname ?? "N/A"
                                            }
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="kinFirstname"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          First Name
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="kinFirstname"
                                            id="kinFirstname"
                                            disabled
                                            defaultValue={
                                              kinDetails?.firstName ?? "N/A"
                                            }
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="kinMid"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Middle Name
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="kinMid"
                                            id="kinMid"
                                            disabled
                                            defaultValue={
                                              kinDetails?.middleName ?? "N/A"
                                            }
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>

                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="kinPhone"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Phone Number
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="kinPhone"
                                            id="kinPhone"
                                            disabled
                                            defaultValue={
                                              kinDetails?.phoneNumber ?? "N/A"
                                            }
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="kinEmail"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Email
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="kinEmail"
                                            id="kinEmail"
                                            disabled
                                            defaultValue={
                                              kinDetails?.emailAddress ?? "N/A"
                                            }
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="relationship"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Relationship
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="relationship"
                                            id="relationship"
                                            disabled
                                            defaultValue={
                                              kinDetails?.relationship ?? "N/A"
                                            }
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="gender"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Gender
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="gender"
                                            id="gender"
                                            disabled
                                            defaultValue={
                                              kinDetails?.gender ?? "N/A"
                                            }
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="relationship"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          State of Residence
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="state"
                                            id="state"
                                            disabled
                                            defaultValue={
                                              kinDetails?.stateofResidence ??
                                              "N/A"
                                            }
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label
                                          htmlFor="dob"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Date of Birth
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="dob"
                                            id="dob"
                                            disabled
                                            defaultValue={
                                              validateDate(
                                                kinDetails?.dateOfBirth,
                                              ) ?? "N/A"
                                            }
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="sm:col-span-6">
                                        <label
                                          htmlFor="address"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Residential Address
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="address"
                                            id="address"
                                            disabled
                                            defaultValue={
                                              kinDetails?.residentialAddress ??
                                              "N/A"
                                            }
                                            className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  )}
                  {activeTab === "documents" && resolvedUserName && (
                    <CustomerDocument userName={resolvedUserName} />
                  )}
                  {activeTab === "settings" && resolvedUserName && (
                    <CustomerSettings
                      id={resolvedUserName}
                      userId={customer?.userId}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>

        {/* Profile Update Modal */}
        <ProfileUpdateModal
          isOpen={profileUpdateModalOpen}
          onClose={() => setProfileUpdateModalOpen(false)}
          customer={customer}
          onSuccess={handleProfileUpdateSuccess}
        />

        {/* Account Update Modal */}
        <AccountUpdateModal
          isOpen={accountUpdateModalOpen}
          onClose={() => setAccountUpdateModalOpen(false)}
          account={selectedAccountForUpdate}
          onSuccess={handleAccountUpdateSuccess}
        />

        {/* Block Customer Modal */}
        <Transition.Root show={open} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            initialFocus={cancelButtonRef}
            onClose={handleClose}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xs sm:w-full sm:p-6">
                    <div>
                      <div className="mt-3 text-center sm:mt-5">
                        <Dialog.Title
                          as="h3"
                          className="text-lg leading-6 font-medium text-gray-900"
                        >
                          Hey, wait!!
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            Are you sure you want to block this customer?
                          </p>
                          <form>
                            <label
                              htmlFor="comment"
                              className="text-left mt-2 block text-sm font-medium text-gray-700"
                            >
                              Comment
                            </label>
                            <div className="mt-1">
                              <input
                                id="comment"
                                name="comment"
                                type="text"
                                placeholder="Enter comment"
                                autoComplete="text"
                                value={commentValue.comment}
                                onChange={formHandler.commentHandler}
                                required
                                className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              />
                              {!formState.commentIsValidated &&
                                formState.commentError && (
                                  <div className="text-red-800">
                                    {formState.commentError}
                                  </div>
                                )}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                      {loading === false ? (
                        <button
                          type="button"
                          className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900 sm:col-start-2 sm:text-sm"
                          onClick={(text) => blockCustomer(text)}
                        >
                          Yes, I do
                        </button>
                      ) : (
                        <HollowDotsSpinner size={15} color="#4D627E" />
                      )}

                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2 text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                        onClick={() => setOpen(false)}
                        ref={cancelButtonRef}
                      >
                        No, I don't
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        {/* Re-initiate Onboarding Modal */}
        <ConfirmModal
          isOpen={reInitiateConfirmOpen}
          onClose={() => setReInitiateConfirmOpen(false)}
          onConfirm={reInitiateCustomer}
          title="Re-initiate Customer Onboarding"
          message={`This will re-initiate the onboarding process for ${
            resolvedUserName || "this customer"
          }. Continue?`}
          confirmText="Proceed"
          cancelText="Cancel"
          isLoading={ninActionLoading === "reinitiate"}
        />
      </Layout>
    </>
  );
}
